import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Properties } from 'src/app/app-config/properties';
import { catchError, map, retry } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import pSBC from 'shade-blend-color';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { SUCCESS_CODE } from '../shared/model/app';
import { StorageService } from '../services/storage.service';
import { DOCUMENT } from '@angular/common';
import { DEFAULT_THEME } from '../util/constant';

@Injectable({
  providedIn: 'root',
})
export class CustomizationService implements Resolve<any> {
  defaultTheme: any = DEFAULT_THEME;
  constructor(private http: HttpClient, private storageService: StorageService, @Inject(DOCUMENT) private _document: HTMLDocument) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.storageService.clearTheme();
    this.storageService.setDefaultTheme(this.defaultTheme);

    this.setDefaultThemes()

    //   return this.getOrgThemeFromURL();
    return true;
  }

  getTheme() {
    return this.http.get(Properties.RETRIEVE_WHITE_LABEL).pipe(
      catchError((e) => {
        return throwError(e);
      })
    );
  }

  getOrgThemeFromURL() {
    return this.http.get(`${Properties.RETRIEVE_ORG_THEME_FROM_URL}`).pipe(
      retry(3),
      map((res: any) => {
        if (res.code == SUCCESS_CODE) {
          this.storageService.setTheme(res.themeVals);
          this.storageService.setDefaultTheme(res.themeVals);
          Object.keys(res.themeVals).map((key) => {
            if (key == 'primary-color' || key == 'base-font') {
              document.documentElement.style.setProperty(`--${key}`, res.themeVals[key]);
              if (key == 'primary-color') {
                this.setVariantPrimaryColors(res.themeVals[key]);
              }
            }
            if (key == 'favicon') {
              this._document.getElementById('appFavicon')?.setAttribute('href', 'data:image/jpeg;base64,' + res.themeVals[key]);
            }
          });
        } else {
          this.storageService.setDefaultTheme(this.defaultTheme);
        }
      }),
      catchError((e) => {
        return throwError(e);
      })
    );
  }

  setDefaultThemes(){
    let themes = this.storageService.getDefaultTheme();
    if(!themes){
      themes = this.defaultTheme;
    }
    Object.keys(themes).map(key=>{
     if(key =='primary-color' || key =='base-font'){
       document.documentElement.style.setProperty(
         `--${key}`,
        themes[key]
       );
       if(key == 'primary-color'){
         this.setVariantPrimaryColors(themes[key]);
       }
     }
     if(key == 'favicon'){
       this._document.getElementById('appFavicon').setAttribute('href', "data:image/jpeg;base64,"+themes[key]);
     }
    });
}

  lighter(color, percent, selectorType) {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = parseInt(`${(R * (100 + percent)) / 100}`);
    G = parseInt(`${(G * (100 + percent)) / 100}`);
    B = parseInt(`${(B * (100 + percent)) / 100}`);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    let RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16);
    let GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16);
    let BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16);

    return document.documentElement.style.setProperty(selectorType, '#' + RR + GG + BB);
  }

  darker(color, percent, selectorType) {
    return this.lighter(color, percent, selectorType);
  }

  setDocStyle(selectorType, color) {
    document.documentElement.style.setProperty(selectorType, color);
  }
  setVariantPrimaryColors(primaryColor) {
    this.setDocStyle('--light-primary-color', pSBC(0.4, primaryColor));
    this.setDocStyle('--lighter-primary-color', pSBC(0.8, primaryColor));
    this.setDocStyle('--lightest-primary-color', pSBC(0.9, primaryColor));
  }
}
